// actions
import {
  OPTIONS_FETCH_SUCCESS,
  VEHICLE_SET_VEHICLE,
  VEHICLE_TOGGLE_MENU,
  VEHICLE_FETCH_SUCCESS,
  VEHICLE_SET_LABELS,
  VEHICLE_SET_MODEL_CODE,
  VEHICLE_SET_NAME,
} from './actions';

const Vehicle = (
  state = {
    vehicles: {},
    name: 'Model S 75D',
    options: {},
    longName: 'Model S Sedan',
    shortName: 'Model S',
    description: '75 kWh Battery',
    rangeValue: 259,
    model: 'MS_2017_75D',
    modelCode: 'MS',
    driveTrain: 'All-Wheel Drive',
    toggle: false,
    label: '',
    btnLabel: '',
    disclaimer: '',
  },
  action,
) => {
  switch (action.type) {
    case VEHICLE_SET_VEHICLE:
      return {
        ...state,
        name: action.vehicle.name,
        longName: action.vehicle.longName,
        shortName: action.vehicle.shortName,
        description: action.vehicle.description,
        rangeValue: action.vehicle.rangeValue,
        model: action.vehicle.model,
        modelCode: action.vehicle.modelCode,
        driveTrain: action.vehicle.driveTrain,
      };
    case VEHICLE_TOGGLE_MENU:
      return {
        ...state,
        toggle: action.toggle,
      };
    case VEHICLE_FETCH_SUCCESS:
      return {
        ...state,
        vehicles: action.vehicles,
      };
    case OPTIONS_FETCH_SUCCESS:
      return {
        ...state,
        options: action.options,
      };
    case VEHICLE_SET_LABELS:
      return {
        ...state,
        label: action.data.label,
        btnLabel: action.data.btnLabel,
        disclaimer: action.data.disclaimer,
      };
    case VEHICLE_SET_MODEL_CODE:
      return {
        ...state,
        modelCode: action.modelCode,
      };
    case VEHICLE_SET_NAME:
      return {
        ...state,
        name: action.name,
      };
    default:
      return state;
  }
};

export default Vehicle;
